import { LocalizedString } from "../../services/general/models";
import { BadgeFill, ItemBadge, MenuItem } from "../../services/menu/models";

const DEFAULT_GRADIENT_ANGLE_DEG = 90;

// Порядок отката подписи — тот же, что у языков меню в general-сторе. Без него фоллбэк шёл по
// порядку ключей JSON, и гость с китайским мог увидеть итальянскую подпись.
const FALLBACK_LANGUAGES = ['ru', 'en', 'it', 'zh'];

export const fillToCss = (fill: BadgeFill): string => {
    if (fill.kind === 'Gradient' && fill.colorTo) {
        return `linear-gradient(${fill.angleDeg ?? DEFAULT_GRADIENT_ANGLE_DEG}deg, ${fill.colorFrom}, ${fill.colorTo})`;
    }

    return fill.colorFrom;
};

/*
* Подпись бейджа. Дефолта из i18n у кастомного бейджа быть не может, поэтому цепочка
* фоллбэков упирается в сами данные: язык гостя → любой заполненный перевод.
* */
export const badgeTitle = (title: LocalizedString, language: string): string => {
    if (title[language]) return title[language] as string;

    const fallback = FALLBACK_LANGUAGES.find((lang) => !!title[lang])
        || Object.keys(title).find((lang) => !!title[lang]);

    return fallback ? (title[fallback] as string) : '';
};

/*
* Бейджи позиции в порядке badgeIds, разложенные по слотам карточки. Неизвестный id
* пропускаем: бейдж могли выключить или удалить, пока вкладка была открыта.
* */
export const resolveItemBadges = (
    item: MenuItem,
    badgesById: { [s: string]: ItemBadge }
) => {
    const badges = (item.data.badgeIds || [])
        .map((badgeId) => badgesById[badgeId])
        .filter((badge) => !!badge);

    return {
        overPhoto: badges.filter((badge) => badge.placement === 'OverPhoto'),
        inline: badges.filter((badge) => badge.placement === 'Inline'),
        // У позиции без фото слота над фото нет — плашки идут одной строкой.
        all: badges,
    };
};
